import React, { memo } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "@/hooks/useTranslation";
import { Save, X } from "lucide-react";

interface AwardFormData {
  title: string;
  issuer: string;
  date: string;
  description: string;
}

interface AwardFormProps {
  formData: AwardFormData;
  onFormDataChange: (field: string, value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  editingId?: string;
}

export const AwardForm = memo(({
  formData,
  onFormDataChange,
  onSave,
  onCancel,
  editingId
}: AwardFormProps) => {
  const { t } = useTranslation('ui');
  
  return (
    <div className="space-y-4 p-4 border rounded-lg bg-muted/50">
      <Input
        placeholder={t('award_form.title_placeholder')}
        value={formData.title}
        onChange={(e) => onFormDataChange('title', e.target.value)}
      />
      <Input
        placeholder={t('award_form.issuer_placeholder')}
        value={formData.issuer}
        onChange={(e) => onFormDataChange('issuer', e.target.value)}
      />
      <Input
        type="month"
        placeholder={t('award_form.date_placeholder')}
        value={formData.date}
        onChange={(e) => onFormDataChange('date', e.target.value)}
      />
      <Textarea
        placeholder={t('award_form.description_placeholder')}
        value={formData.description}
        onChange={(e) => onFormDataChange('description', e.target.value)}
      />
      <div className="flex gap-2">
        <Button onClick={onSave} disabled={!formData.title}>
          <Save className="h-4 w-4 mr-2" />
          {t('award_form.save')}
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
        >
          <X className="h-4 w-4 mr-2" />
          {t('award_form.cancel')}
        </Button>
      </div>
    </div>
  );
});

AwardForm.displayName = "AwardForm";